// extracted by mini-css-extract-plugin
module.exports = {"HoverIndicator":"HoverIndicator_HoverIndicator__3eALf"};